import React from 'react';
import Modal from '../../../../../../../components/Modal';
import html2pdf from 'html2pdf.js';
import PropTypes from 'prop-types';

const Modals = ({ details, isOpen, onClose }) => {
  const handlePrint = async () => {
    const options = {
      margin: 60, // Specify the margin for all sides (top, right, bottom, left)
      image: { type: 'jpeg', quality: 0.98 }, // Set the image type and quality (optional)
      html2canvas: { scale: 3 }, // Set the scale for better quality (optional)
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' } // Set the document format and orientation (optional)
    };
    const contentWrapper = document.getElementById('content');
    const contentClone = contentWrapper.cloneNode(true);

    const button = contentClone.querySelector('#printButton');
    button.style.display = 'none';
    await html2pdf().set(options).from(contentClone).save('MCAnswerBreakdownReport.pdf');
  };

  return (
    <Modal titleName={details?.title} isOpen={isOpen} onClose={onClose}>
      <div id="content" className="d-flex flex-column gap-2">
        <div className="m-2">
          <strong>{details?.subTitle}</strong>
        </div>

        <div dangerouslySetInnerHTML={{ __html: details?.description }}></div>
        <div className="d-flex justify-content-center mt-4">
          <button id="printButton" onClick={handlePrint} className="btn btn-castleWhite">
            Print
          </button>
        </div>
      </div>
    </Modal>
  );
};

Modals.propTypes = {
  details: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    description: PropTypes.string,
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Modals;
